export const ARTWORK_ID_PARAM = 'artworkId'
export const USER_ID_PARAM = 'userId'



// WEBPACK FOOTER //
// ./src/routes/params.js